module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("1. Who Discovered Fire Island?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. How Fire Island Got Its Name")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Captain Kidd’s Fire Island Treasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Royal Fishes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. West Sayville’s Widow Molly Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The First Purple Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Truth About Fire Island Pirate Jeremiah Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Mystery at Old Inlet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Sumpwams Creek Incident")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Memory of Margaret Fuller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Call Him Ishmael")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Face in the Rigging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Fire Island’s Splinter Fleet Navy Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Bay Shore and Its Near-Forgotten Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. USS "), _c('i', [_vm._v("Northern Pacific")]), _vm._v(" and the Heroes of Fire Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Fire Island’s Flying Santa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0